import { broadenSearchQuery } from '@theme/search-query-broaden';

/**
 * Broadens the `q` value of any `[role="search"]` form on submit, so a
 * plain full-page search navigation gets the same spacing-variant matching
 * as predictive search. The visible input is left untouched — only the
 * outgoing request's query changes.
 */
document.addEventListener(
  'submit',
  (event) => {
    const form = /** @type {HTMLElement} */ (event.target);
    if (!(form instanceof HTMLFormElement) || form.getAttribute('role') !== 'search') return;

    const queryInput = form.elements.namedItem('q');
    if (!(queryInput instanceof HTMLInputElement) || !queryInput.value.trim()) return;

    // Build the destination before cancelling the submit. If anything here
    // fails (older in-app browsers, missing URL/FormData support) we bail out
    // and let the form submit normally rather than blocking search entirely.
    let destination;
    try {
      const broadened = broadenSearchQuery(queryInput.value);
      if (broadened === queryInput.value) return;

      const url = new URL(form.action || location.href, location.origin);
      url.search = '';
      new FormData(form).forEach((value, key) => {
        url.searchParams.set(key, key === 'q' ? broadened : /** @type {string} */ (value));
      });
      destination = url.toString();
    } catch {
      return;
    }

    event.preventDefault();
    window.location.href = destination;
  },
  { capture: true }
);
